<div class="warning-indicator-cell" [class.has-warning]="hasWarning()">
  <span class="cell-value">{{ value() }}</span>

  @if (hasWarning()) {
  <div class="warning-badge" title="Warning">
    <img src="/images/warning.svg" alt="Warning" class="warning-icon" />
  </div>
  }
</div>
